@if (
  {
    allTeams: allTeams$ | async
  };
  as state
) {
  <teams-header (searchValueChange)="searchValue$.next($event)" [allTeams]="state.allTeams" />
  <teams-table [searchValue$]="searchValue$" [allTeams]="state.allTeams" />
} @else {
  <div class="oph-loading-container">
    <oph-loading />
  </div>
}
